export default __webpack_public_path__ + "static/media/Pulse_Generators.616217be.png";